import type { Asset } from "@/Dashboard/pages/AssetLibrary/types";
import { REQUEST_STATUSES } from "@/constants/requestStatuses";

import * as types from "./types";

interface ActionPayload {
  assets: Asset[];
}

interface Action {
  type: string;
  payload: ActionPayload;
}

const initialState = {
  asset: {},
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export function currentAssetReducer(state = initialState, action: Action) {
  switch (action.type) {
    case types.GET_CURRENT_ASSET:
    case types.REFRESH_CURRENT_ASSET:
    case types.SET_CURRENT_ASSET_REQUEST_STATUS:
      return { ...state, ...action.payload };
    case types.RESET_CURRENT_ASSET:
      return { ...initialState };
    default:
      return state;
  }
}
